<template>
  <v-container
    id="dashboard"
    tag="section"
  >
    <v-row />
  </v-container>
</template>

<script>
  import $ from 'jquery'
  export default {
    name: 'Main',

    data () {
      return {
        headers: {
          file: [
            {
              text: '',
              value: 'save',
            },
            {
              text: 'Название',
              value: 'filename',
            },
            {
              text: 'Описание',
              value: 'comment',
            },
          ],
        },
        loader: {
          show: false,
        },
        dialog: {
          client: {
            show: false,
            data: {
              name: '',
              legal: {
                name: {},
              },
              files: [],
            },
          },
        },
        suggestions: {
          legal: false,
        },
      }
    },
    methods: {
      create_client: function () {
        this.axios.post('/api/client/create/', this.dialog.client.data)
          .then(response => {
            if (!response.data.error) {
              this.$store.commit('snackbar', 'Заявка успешно отправлена')
              this.dialog.client.show = false
            } else {
              this.$store.commit('snackbar', response.data.data || 'Ошибка при сохранении данных')
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', 'Ошибка при сохранении данных')
          })
      },
      legal_input: function () {
        if (this.suggestions.legal) return
        this.suggestions.legal = true
        $('[name=inn]').suggestions({
          token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
          type: 'PARTY',
          count: 5,
          onSelect: data => {
            console.log(data)
            this.dialog.client.data.legal.name.full = data.data.name.full_with_opf
            this.dialog.client.data.legal.name.short = data.data.name.short_with_opf
            this.dialog.client.data.legal.inn = data.data.inn
            this.dialog.client.data.legal.kpp = data.data.kpp
            this.dialog.client.data.legal.ogrn = data.data.ogrn
            this.dialog.client.data.legal.okved = data.data.okveds || [data.data.okved]
            this.dialog.client.data.legal.director = {}
            if (data.data.management) {
              this.dialog.client.data.legal.director.name = data.data.management.name
              this.dialog.client.data.legal.director.post = data.data.management.post
            }
            this.dialog.client.data.tax = {}
          },
        })
      },
      getDoc: function (item) {
        console.log(item)
        const form = $('<form>', {
          target: '_blank',
          action: '/api/common/file/get',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item.id,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
      upload: function (event) {
        const files = event.target.files
        if (files[0]) {
          this.loader.show = true
          const data = new FormData()
          data.append('file', files[0])
          this.axios
            .post('/api/common/file/', data, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then(response => {
              if (response.data.error) {
                this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              } else {
                for (const x in response.data.data) {
                  this.dialog.client.data.files.push(response.data.data[x])
                }
              }
              this.loader.show = false
            })
            .catch(error => {
              console.log(error)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              this.loader.show = false
            })
        }
      },
    },
  }
</script>
